import React, { useState } from 'react'
import { Row, Col, Button } from 'react-bootstrap'
import axios from 'axios';

import LoadingSpinner from '../../LoadingSpinner';
import NPTreeMenu from '../../NPTreeMenu'
import NewsForm from './NewsForm'
import constants from '../../util/constants';
import NPPanel from '../../NPPanel';

const { API_BASE_URL } = constants;

const availableLegalEntity = [
    {
        label: 'Everyone can access',
        value: ''
    },
    {
        label: 'Kraft',
        value: 'NPBA'
    },
    {
        label: 'GreaseProof',
        value: 'NP'
    }
]
const availableUserType = [
    {
        label: 'Internal',
        value: 1
    },
    {
        label: 'Agent',
        value: 2
    },
    {
        label: 'Customer',
        value: 3
    }
]
const emptyEntry = {
    Title: '',
    NewsContent: '',
    LegalEntity: availableLegalEntity[0].value,
    UserType: availableUserType[0].value,
    Created: null,
    CreatedBy: null,
    Published: false,
    Attachment: null
}

class AdminNews extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            entry: emptyEntry,
            prevEntry: null, // Kan vara bra f�r reset etc
            errorMessage: false,
            successMessage: false,
            entryLoading: false,
            treeLoading: true,
            treeData: [],
            header: this.props.apiToken ? {
                'Authorization': 'Bearer ' + this.props.apiToken,
                'Accept': 'application/octet-stream'
            } : {},
        }

        this.getTreeMenuItems = this.getTreeMenuItems.bind(this)
        this.dataCallback = this.dataCallback.bind(this)
        this.createNewEntry = this.createNewEntry.bind(this)
        this.updateEntry = this.updateEntry.bind(this)
        this.saveEntry = this.saveEntry.bind(this)
        this.deleteEntry = this.deleteEntry.bind(this)
    }

    async componentDidMount() {
        await this.getTreeMenuItems();
    }

    async getTreeMenuItems() {
        axios.get(API_BASE_URL + 'News/GetNewsForEdit', { headers: this.state.header })
            .then(result => {
                if (result && result.data) {
                    result.data.forEach((e) => {
                        if (e.nodes)
                            e.nodes.forEach((n) => {
                                n.url = (API_BASE_URL + 'News/GetSingleNewsForEdit?id=' + n.url)
                            });
                        e.url = null;
                    });
                }
                this.setState({ treeLoading: false, errorMessage: null, treeData: result.data })
            })
            .catch(error => {
                this.setState({ treeLoading: false, errorMessage: 'Problem loading news' })
            });
    }

    dataCallback(data) {
        this.setState({
            entry: data.data,
            prevEntry: data.data,
            entryLoading: false
        });
    }

    createNewEntry() {
        this.setState({
            entry: emptyEntry,
            prevEntry: emptyEntry
        })
    }

    updateEntry(field, value) {
        this.setState({
            entry: {
                ...this.state.entry,
                [field]: value
            }
        })
    }

    saveSuccessful(id) {
        this.setState({ successMessage: 'Success' });
        this.setState({
            entry: {
                ...this.state.entry,
                Id: id
            }
        })
        this.getTreeMenuItems();
    }


    saveEntry() {
        axios.post(API_BASE_URL + 'News/SaveSingleNews', this.state.entry, { headers: this.state.header })
        .then(result =>{

            const form = new FormData();
            form.append("newsId", result.data);

            //Add new or replace existing file
            if(this.state.entry.Attachment != null && this.state.entry.Attachment.File != null)
            {
                form.append('File0', this.state.entry.Attachment.File, this.state.entry.Attachment.Title);
            }

            //Existing file should not be replaced.
            else if(this.state.entry.Attachment != null && this.state.entry.Attachment.File == null)
            {
                this.saveSuccessful(result.data);
                return;
            }

            axios.post(API_BASE_URL + 'News/SaveAttachment', form, { headers: this.state.header })
            .catch(error => {
                let recievedError = error.response.data.length > 0 ? error.response.data : "Unable to save attachment"
                this.setState({
                    errorMessage: recievedError,
                }, () => setTimeout(() => { this.setState({ errorMessage: false }) }, 5000));
                return;
            })

            this.saveSuccessful(result.data);
        })    
        .catch(error=>{
            this.setState({
                errorMessage: error?.response?.data ?? "Unable to save news"
            }, () => setTimeout(() => { this.setState({ errorMessage: false }) }, 5000))          
        });
    }

    deleteEntry() {
        axios.post(API_BASE_URL + 'News/DeleteSingleNews', this.state.entry, { headers: this.state.header })
            .then(result => {
                this.setState({
                    entry: emptyEntry,
                    prevEntry: emptyEntry
                })
                this.getTreeMenuItems()
            })
            .catch(error => {
                this.setState({
                    errorMessage: true
                }, () => setTimeout(() => { this.setState({ errorMessage: false }) }, 5000))
            });
    }

    render() {
        const { entry, prevEntry, entryLoading, treeLoading, treeData, errorMessage, successMessage, header } = this.state
        const { createNewEntry, deleteEntry, dataCallback, updateEntry, saveEntry } = this

        return (
            <NPPanel>
                <Row className="d-flex">
                    <Col md={4} lg={3} className="news--treeMenu">
                        <Button bsStyle="primary" className="btn btn-sm btn-primary" onClick={createNewEntry}>Create new entry</Button>
                        { 
                            treeLoading
                                ? <LoadingSpinner isLoading={true} />
                                : <NPTreeMenu data={treeData} className={'margin-top-4'} level0DefaultOpen={true} dataCallback={dataCallback} header={header} />
                        }
                    </Col>
                    <Col md={8} lg={9}>
                        {
                            entryLoading
                                ? <LoadingSpinner isLoading={true} />
                                : <NewsForm entry={entry}
                                    prevEntry={prevEntry}
                                    updateEntry={updateEntry}
                                    saveEntry={saveEntry}
                                    deleteEntry={deleteEntry}
                                    errorMessage={errorMessage}
                                    successMessage={successMessage}
                                    availableLegalEntity={availableLegalEntity}
                                    availableUserType={availableUserType} />
                        }   
                    </Col>
                </Row>
            </NPPanel>


        );
    }
}

export default AdminNews;